import { GranularityInDays, type LensGranularity } from "../models";

import { truncateDateToUTC12AMTime } from "./truncateDateToUTC12AMTime";

const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;

export interface PayoutDateRange {
    startDate?: string;
    endDate?: string;
}

/**
 * Converts a LensGranularity selection into ISO date strings for the payout stats API.
 *
 * Uses the same UTC 12AM truncation as makeUTCStartEndTimestamp.
 * End date is +1 day to include the current day (see LensCreatorRewardsInsights.tsx).
 * Lifetime returns undefined dates (server returns all-time data).
 */
export const makePayoutDateRange = (granularity: LensGranularity): PayoutDateRange => {
    const rangeDays = GranularityInDays[granularity];

    if (rangeDays === undefined) {
        return {};
    }

    const todayUTC = truncateDateToUTC12AMTime(new Date());
    const endTimestamp = todayUTC + ONE_DAY_IN_MS;
    const startTimestamp = todayUTC - rangeDays * ONE_DAY_IN_MS;

    return {
        startDate: new Date(startTimestamp).toISOString(),
        endDate: new Date(endTimestamp).toISOString(),
    };
};

export const makePreviousPayoutDateRange = (granularity: LensGranularity): PayoutDateRange => {
    const rangeDays = GranularityInDays[granularity];

    if (rangeDays === undefined) {
        return {};
    }

    const todayUTC = truncateDateToUTC12AMTime(new Date());
    const endTimestamp = todayUTC - rangeDays * ONE_DAY_IN_MS;
    const startTimestamp = endTimestamp - rangeDays * ONE_DAY_IN_MS;

    return {
        startDate: new Date(startTimestamp).toISOString(),
        endDate: new Date(endTimestamp).toISOString(),
    };
};
